module.exports = __webpack_public_path__ + "image/header-select5.png";